module.exports = __webpack_public_path__ + "img/5.22d263f5.svg";